import { observe } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { Prompt, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ButtonRow from "src/Components/ButtonRow";
import DataTable from "src/Components/DataTable";
import { IList } from "src/Components/DataTable/DataTable";
import EInput, { EButton, EInputMask } from "src/Components/EInput";
import WellFooter from "src/Components/Footer/WellFooter";
import { IDispatchTruck } from "src/Interfaces/DispatchInterface";
import { IProduct } from "src/Interfaces/TestInterface";
import { IWellCloseReview, IWellCloseReviewProduct, WellCloseReviewProduct } from "src/Interfaces/WellInterface";
import DisplayRounding from "src/Services/DisplayRounding";
import { MessageStore } from "src/Stores/Messages/Messages";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import DeepCopy from "src/UtilityFunctions/DeepCopy";
import { ReceiveDispatchModal } from "../../Dispatch/ReceiveDispatch/ReceiveDispatchModal";
import WorkflowHeader from "../../WorkflowHeader/WorkflowHeader";
import WellCloseButton from "../WellCloseButton";
import WellRevertCloseButton from "../WellRevertCloseButton";
import CostsTotalHeader from "./CostsTotalHeader";

const mask = new EInputMask();
@inject('stores')
@observer
class ProductReview extends React.Component {
    public props: any;
    private WellsStore: WellsStore;
    private MessageStore: MessageStore;
    private TestsStore: TestsStore;
    private wellReviewDisposer: any;
    private modalDataSet: IList;
    private productList: IProduct[] = [];

    public state = {
        dataSet: undefined as unknown as IList,
        isDirty: false,
        modal: false,
        modalDataSet: this.modalDataSet,
        modalDataSetMaster: this.modalDataSet,
        newInventoryList: [] as boolean[],
        newInventoryListMaster: [] as boolean[],
        pickupDispatchModal: false,
        productList: this.productList,
        productListMaster: this.productList,
        showMasterItems: false,
        wellCloseReview: undefined as unknown as IWellCloseReview,
    };

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.TestsStore = props.stores.TestsStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {
        this.createObservers();
        if (this.WellsStore.well) {
            this.WellsStore.getWellCloseReview();
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(() => {
                    this.WellsStore.getWellCloseReview();
                });
        }
        this.getProductList().then(() => {
            this.getMasterProductList();
        });
    }

    public componentWillUnmount() {
        this.disposeObservers();
    }

    private createObservers() {
        this.wellReviewDisposer = observe(this.WellsStore, 'wellCloseReview', change => {
            this.setState({
                wellCloseReview: change.newValue
            }, () => {
                this.formatDataTable();
            });
        });
    }

    private disposeObservers() {
        this.wellReviewDisposer();
    }

    private getProductList() {
        return this.TestsStore.getProductList(this.props.match.params.wellId)
            .then(
                (productList: any) => {
                    this.setState({
                        productList
                    }, () => {
                        this.formatModalDataTable();
                    });
                }
            );
    }

    private getMasterProductList() {
        this.TestsStore.getProductMasterList()
            .then(productListMaster => {
                if (productListMaster) {
                    this.setState({ productListMaster }, () => {
                        this.formatModalDataTable();
                    });
                }
            });
    }

    public formatDataTable = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const headers = [
            'Product',
            'Size',
            'Unit',
            'Price',
            'Taxable',
            'Total Received',
            'Total Adjusted',
            'Total Returned',
            "Returned Overage",
            'Total Used',
            'Closing',
            'Credited',
            'Difference (Amount)',
            'Difference ($)',
            'Difference (%)',
            'Used (Reconciled)',
            'Final Used ($)',
        ];

        if (wellCloseReview === undefined) {
            this.setState({
                dataSet: { headers, rows: [] }
            });
        }
        const wellCloseProducts = wellCloseReview.products;
        const rows = wellCloseProducts.map((wcp, index) => {
            return [
                {
                    content: wcp.product.name
                },
                {
                    content: wcp.product.size
                },
                {
                    content: wcp.product.unit
                },
                {
                    content: wcp.isDelible ? this.renderPriceInput(wcp, index) : mask.currency(wcp.price),
                    sortItem: wcp.price,
                    type: wcp.isDelible ? 'render' : ''
                },
                {
                    content: this.renderTaxableCheckbox(wcp, index),
                    sortItem: wcp.isTaxable,
                    type: 'render',
                },
                {
                    content: wcp.totalReceived
                },
                {
                    content: wcp.totalAdjusted
                },
                {
                    content: wcp.totalReturned
                },
                {
                    content: wcp.returnedOverage
                },
                {
                    content: wcp.totalUsed
                },
                {
                    content: wcp.closingAmount
                },
                {
                    content: this.renderCreditedInput(wcp, index),
                    key: wcp.id,
                    sortItem: wcp.credited,
                    type: 'render'
                },
                {
                    content: this.renderDifferenceAmount(wcp),
                    sortItem: wcp.difference,
                    type: 'render'
                },
                {
                    content: this.renderTotalCost(wcp),
                    sortItem: wcp.totalCost,
                    type: 'render'
                },
                {
                    content: this.renderFinalDifference(this.finalDifferenceValue, wcp),
                    sortItem: this.finalDifferenceValue(wcp),
                    type: 'render',
                },
                {
                    content: this.renderUsedRec(this.usedRecValue, wcp, index),
                    sortItem: this.usedRecValue(wcp),
                    type: 'render',
                },
                {
                    content: this.renderFinalUsed(this.finalUsedValue, wcp),
                    sortItem: this.finalUsedValue(wcp),
                    type: 'render',
                },


            ];
        });
        this.setState({
            dataSet: { headers, rows }
        });
    }

    public handlePickupModalToggle = () => {
        this.setState({
            pickupDispatchModal: !this.state.pickupDispatchModal
        });
    }

    public handlePickupTruck = (dispatchTruck: IDispatchTruck) => {
        const wellCloseReview = DeepCopy(this.state.wellCloseReview) as IWellCloseReview;
        wellCloseReview.dispatchTrucksReturned.push(dispatchTruck);
        dispatchTruck.returnedWellCloseReviewId = this.state.wellCloseReview.id;
        dispatchTruck.items.forEach(di => {
            const dispatchProduct = wellCloseReview.products.find(pi => di.productId === pi.product.id && pi.credited > 0);
            if (dispatchProduct) {
                dispatchProduct.totalReturned = Number(dispatchProduct.totalReturned) + Number(di.quantity);
                dispatchProduct.closingAmount = Number(dispatchProduct.closingAmount) - Number(di.quantity);
                dispatchProduct.credited = Number(dispatchProduct.credited) - Number(di.quantity);
            } else {
                this.MessageStore.addMessage(`Cannot Pickup Product ${di.product.name}, cancelling truck receive.`, 'danger');
                return;
            }
        });
        this.WellsStore.saveWellCloseReview(wellCloseReview).then((data: any) => {
            if (data) {
                this.MessageStore.addMessage(`Dispatch Truck Pickup Acknowledged`, 'success');
                this.WellsStore.getWellCloseReview();
                this.setState({
                    isDirty: false,
                });
            }
        });
        this.setState({
            pickupDispatchModal: false,
        });
    }

    private renderPriceInput = (wcre: IWellCloseReviewProduct, index: number) => () => {
        return (
            <EInput
                key={"price" + wcre.id}
                name={"price" + index}
                id={"price" + index}
                value={wcre.price}
                data-validation="decimal"
                data-mask="currency"
                onChange={this.handleChangePrice(index)}
            />
        );
    }

    private handleChangePrice = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        const wcp = wellCloseReview.products[index];
        wcp.price = event.target.value;
        if (Number.isFinite(Number(wcp.price))) {
            wcp.difference = Number(DisplayRounding.RoundStrict(wcp.closingAmount - Number(wcp.credited), 2));
            wcp.totalCost = wcp.difference * wcp.price;
        } else {
            wcp.difference = 0;
            wcp.totalCost = 0;
        }
        this.setState({ isDirty: true, wellCloseReview });
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private handleTaxableClick = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        wellCloseReview.products[index].isTaxable = !wellCloseReview.products[index].isTaxable;
        this.setState({ wellCloseReview });
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private renderTaxableCheckbox = (wcre: IWellCloseReviewProduct, index: number) => () => {
        return (
            <div className="multi-select-row">
                <Input onChange={this.handleTaxableClick(index)} checked={wcre.isTaxable} type="checkbox" value="" />
            </div>
        );
    }

    private usedRecValue = (wcp: IWellCloseReviewProduct) => {
        const usedRec = Number(DisplayRounding.RoundStrict(wcp.totalUsed + wcp.difference, 2));
        return usedRec;
    }

    private renderUsedRec = (callback: any, wcp: IWellCloseReviewProduct, index: number) => () => {
        return (
            <EInput
                key={wcp.id}
                name={"totalUsed" + index}
                id={"totalUsed" + index}
                value={callback(wcp)}
                data-validation="decimal"
                disabled={true}
            />
        );
    }

    private renderFinalUsed = (callback: any, wcp: IWellCloseReviewProduct) => () => {
        return mask.currency(callback(wcp));
    }

    private finalUsedValue = (wcp: IWellCloseReviewProduct) => {
        const usedRec = wcp.totalUsed + wcp.difference;
        const finalUsed = usedRec * wcp.price;
        return finalUsed;
    }

    private finalDifferenceValue = (wcp: IWellCloseReviewProduct) => {
        const diffPercent = wcp.difference / wcp.totalUsed;

        return isFinite(diffPercent) ? diffPercent : 0;
    }

    private renderFinalDifference = (callback: any, wcp: IWellCloseReviewProduct) => () => {
        const finalDiff = callback(wcp) * 100;
        return finalDiff.toFixed(2) + '%';
    }

    private renderCreditedInput = (wcp: IWellCloseReviewProduct, index: number) => () => {
        return (
            <EInput
                key={wcp.id}
                name={"credited" + index}
                id={"credited" + index}
                value={wcp.credited}
                data-validation={wcp.product.isBulk ? "decimalnegative" : "negative"}
                decimal-places="2"
                onChange={this.handleCreditedChange(index)}
            />
        );
    }

    private renderDifferenceAmount = (wcp: IWellCloseReviewProduct) => () => {
        return wcp.difference;
    }

    private renderTotalCost = (wcp: IWellCloseReviewProduct) => () => {
        return mask.currency(wcp.totalCost);
    }

    private handleCreditedChange = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        const wcp = wellCloseReview.products[index];
        wcp.credited = event.target.value;
        if (Number.isFinite(Number(wcp.credited))) {
            wcp.difference = Number(DisplayRounding.RoundStrict(wcp.closingAmount - Number(wcp.credited), 2));
            wcp.totalCost = wcp.difference * wcp.price;
        } else {
            wcp.difference = 0;
            wcp.totalCost = 0;
        }
        this.setState({ isDirty: true, wellCloseReview });
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private updateWellCloseReview = () => {
        this.WellsStore.saveWellCloseReview(this.state.wellCloseReview)
            .then(data => {
                if (data) {
                    this.setState({ isDirty: false });
                }
            });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ($target.name === 'previousButton') {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/review');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/ebpreview');
        }
    }

    private formatModalDataTable() {
        const newDataList: any[] = [];
        const newDataListMaster: any[] = [];

        const tableHeaders = [
            'Product',
            'Category',
            'Unit',
            'Size',
            'SG',
            'Weight',
            'Price'
        ];
        if (this.state.productList) {
            this.state.productList.map((product: IProduct, index: number) => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.specificGravity
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }

        if (this.state.productListMaster) {
            this.state.productListMaster.map(product => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.specificGravity
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataListMaster.push(newObject);
            });
        }

        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };

        const listStructureMaster = {
            headers: tableHeaders,
            rows: newDataListMaster,
        };

        this.setState({
            modalDataSet: listStructure,
            modalDataSetMaster: listStructureMaster,
        });
    }

    private toggleModal = () => {
        if (this.state.modal) {
            this.getProductList();
            this.setState({
                newInventoryList: [],
                showMasterItems: false
            });

        }
        this.setState({
            modal: !this.state.modal
        }, () => {
            this.formatModalDataTable();
        });
    }

    private handleListToggle = () => {
        this.setState({
            showMasterItems: !this.state.showMasterItems,
        });
    }

    private handleMultiSelect = (index: number) => {
        if (this.state.showMasterItems) {
            const newInventoryListMaster = this.state.newInventoryListMaster;
            newInventoryListMaster[index] = !newInventoryListMaster[index];
            this.setState({ newInventoryListMaster });
        } else {
            const newInventoryList = this.state.newInventoryList;
            newInventoryList[index] = !newInventoryList[index];
            this.setState({ newInventoryList });
        }
    }

    private handleDelete = (index: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        const productId = wellCloseReview.products[index].id;
        this.WellsStore.deleteProductItem(productId)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Product Successfully Deleted', 'success');
                }
                  this.WellsStore.getWellCloseReview();
            },
            );
        this.formatDataTable();

    }

    private handleSave = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const products = wellCloseReview.products;
        this.state.productList.map((product: IProduct, index: number) => {
            if (this.state.newInventoryList[index]) {
                const newInventoryProduct = new WellCloseReviewProduct();
                newInventoryProduct.isTaxable = product.isTaxable;
                newInventoryProduct.product = product;
                newInventoryProduct.price = product.retailPrice;
                newInventoryProduct.productId = product.id;
                products.push(newInventoryProduct);
            }
        });

        this.state.productListMaster.forEach((product: IProduct, index: number) => {
            if (this.state.newInventoryListMaster[index]) {
                const newInventoryProductMaster = new WellCloseReviewProduct();
                newInventoryProductMaster.isTaxable = product.isTaxable;
                newInventoryProductMaster.product = product;
                newInventoryProductMaster.price = product.retailPrice;
                newInventoryProductMaster.productId = product.id;
                products.push(newInventoryProductMaster);
            }
        });

        wellCloseReview.products = products;
        this.setState({
            isDirty: true,
            wellCloseReview
        }, () => {
            this.formatDataTable();
        });
        this.WellsStore.updateWellCloseReview(wellCloseReview);
        this.toggleModal();
    }

    private getDelibleList = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const wellCloseReviewProducts = wellCloseReview.products;
        return wellCloseReviewProducts.map(wcrp => wcrp.isDelible);
    }

    public render() {
        const wellCloseReview = this.state.wellCloseReview;
        const wellId = this.props.match.params.wellId;
        if (wellCloseReview === undefined) {
            return <div>
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />
            </div>;
        }
        return <div>
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />
            <CostsTotalHeader />
            {
                wellCloseReview.pickupsPending &&
                wellCloseReview.pickupsPending.length > 0 &&
                <Row>
                    <Col>
                        <Button color="primary" onClick={this.handlePickupModalToggle}>View Pending Pickups</Button>
                    </Col>
                </Row>
            }
            <Row>
                <Col>
                    <DataTable
                        list={this.state.dataSet}
                        onNew={{ callback: this.toggleModal, text: 'Add Products', }}
                        onDelete={this.handleDelete}
                        delibleList={this.getDelibleList()}
                    />
                </Col>
            </Row>
            <ButtonRow>
                <WellRevertCloseButton />
                <WellCloseButton />
                <Link className="secondary btn btn-secondary" style={{ marginRight: 10 }} target="_blank" to={`/print/well/${wellId}/wellclosereviewpdf`} >Snapshot</Link>
                {this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellCloseReview}>Save</EButton>}
                <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                <WellFooter />
            </ButtonRow>
            <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} size="lg">
                <ModalHeader toggle={this.toggleModal}>Product List</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            <DataTable
                                list={this.state.showMasterItems ? this.state.modalDataSetMaster : this.state.modalDataSet}
                                onMultiSelect={this.handleMultiSelect}
                                multiSelectChecked={this.state.showMasterItems ? this.state.newInventoryListMaster : this.state.newInventoryList}
                            />
                        </Col>
                    </Row>
                    {/* 
                    MUD-2025  Archive the user defined product feature so comment for now.
                    This can be removed later if the feature is removed.
                    <div className="add-table-row">
                        <Button className="primary add-new-button" onClick={this.toggleProductModal}>
                                    <FontAwesomeIcon icon="plus" />
                                    { ' User Defined Product' }
                        </Button>
                    </div> */}
                    <div className="add-table-row">
                        <Button color={this.state.showMasterItems ? 'outline-primary' : 'primary'} onClick={this.handleListToggle}>{this.state.showMasterItems ? 'View Regional Items' : 'View Non-Regional Items'}</Button>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className="secondary" onClick={this.toggleModal}>Cancel</Button>
                    <Button color="primary" onClick={this.handleSave}>Add to Inventory</Button>
                </ModalFooter>
            </Modal>
            {
                this.state.pickupDispatchModal &&
                <ReceiveDispatchModal type="Pick Up" dispatch={wellCloseReview.pickupsPending} isOpen={this.state.pickupDispatchModal} toggleOpen={this.handlePickupModalToggle} onReceive={this.handlePickupTruck} />
            }
        </div>;
    }
}

export default withRouter(ProductReview);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/ProductReview.tsx